import { render, staticRenderFns } from "./PosterExhibition.vue?vue&type=template&id=7d865f11&lang=pug&"
import script from "./PosterExhibition.vue?vue&type=script&lang=js&"
export * from "./PosterExhibition.vue?vue&type=script&lang=js&"
import style0 from "./PosterExhibition.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports